import {createApp} from 'vue';
import App from './App.vue';
import './assets/main.scss';
import TransferStateService from 'transfer-state';

const appContainerSelector: string = '#interactive-map';
TransferStateService.getInstance().init(appContainerSelector);
createApp(App).mount(appContainerSelector);
